import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FlexBox } from "../flexBox/FlexBox.js";
import { combineClasses } from "../../utilities/combineClasses.js";
import Background_module from "./Background.module.js";
import { theme } from "../../theme/index.js";
const Background = /*#__PURE__*/ forwardRef(({ className, style, color = 'white', ...props }, ref)=>/*#__PURE__*/ jsx(FlexBox, {
        className: combineClasses(className, Background_module.background),
        style: {
            '--background--background-color': theme.color[color],
            ...style
        },
        ...props,
        ref: ref
    }));
Background.displayName = 'Background';
export { Background };
